import "isomorphic-fetch";
import "rxjs";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import { ConnectedRouter } from "react-router-redux";
import bootstrap from "core/bootstrap";
import { history } from "core/router";
import * as sentry from "core/integrations/sentry";
import { Notifications } from "./components/generic/layout";
import { store, persistor } from "./modules";
import Pages from "./components/pages";
import mixpanel from "mixpanel-browser";
import { MixpanelProvider } from "core/utils";

mixpanel.init(process.env.REACT_APP_MIXPANEL_KEY, {
  persistence: "localStorage"
});
bootstrap(history);

const App = () => (
  <sentry.ErrorBoundary>
    <MixpanelProvider mixpanel={mixpanel}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ConnectedRouter history={history}>
            <Pages />
          </ConnectedRouter>
          <Notifications />
        </PersistGate>
      </Provider>
    </MixpanelProvider>
  </sentry.ErrorBoundary>
);

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js